import {inject, injectable} from 'inversify';

import type {BaseDomainFactory} from '../Base/BaseDomain.factory';

import {ModelsRegistry} from '../../system/modelsRegistry/ModelsRegistry';
import {WsMessageModel} from './WsMessage.model';

@injectable()
export class WsMessageFactory
  implements BaseDomainFactory<WsMessageModel, WsMessageModel.Props>
{
  constructor(
    @inject(ModelsRegistry)
    private readonly modelsRegistry: ModelsRegistry,
  ) {}

  create(props: WsMessageModel.Props): WsMessageModel {
    return this.modelsRegistry.put(new WsMessageModel(props));
  }
}
